import { createFileRoute } from '@tanstack/react-router';
import { CommentAutoReplyEditorPage } from '@/features/marketing';

/** The salon's automatic reply for every post; a static segment, so it wins over `comment-dm_.$automationId`. */
export const Route = createFileRoute('/_auth/$orgId/marketing/comment-dm_/auto-reply')({
  component: CommentAutoReplyRoute,
});

function CommentAutoReplyRoute() {
  const { orgId } = Route.useParams();
  return <CommentAutoReplyEditorPage orgId={orgId} />;
}
